import {
  AddCircle,
  Cancel,
  CheckCircleOutlined,
  Flaky,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ProposalStatus,
  getProposalStatusTranslationKey,
} from '~/data/proposals';

type PropsType = {
  status: ProposalStatus;
  SvgIconProps?: SvgIconProps;
  children?: ReactNode;
};

export const WorkflowProposalStatus = (props: PropsType) => {
  const { status, SvgIconProps, children } = props;
  const { t } = useTranslation();

  const StatusIcon = () => {
    switch (status) {
      case ProposalStatus.COMPLETED:
        return <CheckCircleOutlined color={'success'} />;
      case ProposalStatus.IN_PROGRESS:
        return <Flaky color={'warning'} />;
      case ProposalStatus.FAILED:
        return <Cancel color={'error'} />;
      case ProposalStatus.PROPOSED:
        return <AddCircle color={'info'} />;
      default:
        return <AddCircle color={'info'} />;
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
      <StatusIcon {...SvgIconProps} />
      <Box>{t(getProposalStatusTranslationKey(status))}</Box>
      {children}
    </Box>
  );
};
